/// <amd-module name="Artifacts/Cargo/commands/Download" />
import { CargoActions } from "Artifacts/Cargo/redux";
import { getDownloadCommandCreator } from "Artifacts/Root/protocols/Commands";

export const createDownloadCommand = getDownloadCommandCreator(CargoActions.download);
